'use client'

import { useState } from "react"
import Image, { ImageProps } from "next/image"
import NoImage from '../illustratores/NoImage'

export default function ImageLoadingHotelCard(ImageProps: ImageProps) {
    const [loadFailed, setLoadFailed] = useState(false)
    return (
        <>
            {(loadFailed || !ImageProps.src) ?
                <div className={ImageProps.className}>
                    <div className='w-full h-full flex items-center justify-center'>
                        <NoImage className='w-1/2' />
                    </div>
                </div> : <Image
                    onError={() => setLoadFailed(true)}
                    {...ImageProps}
                />}
        </>
    )
}